/**
 * Reviews Slick
 */
$('#reviewsList').slick({
  slidesToShow: 1,
  arrows: false,
  dots: true,
  speed: 1000,
  adaptiveHeight: true,
  centerMode: false,
  mobileFirst: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        cssEase: 'linear'
      }
    }
  ]
});